import AnimatedBackgroundLayout from './AnimatedBackgroundLayout'
import BaseLayout from './BaseLayout'
import ParticlesBackground from '../components/ParticlesBackground'
import SideMenu from '../components/menu/SideMenu'
import TopBar from '../components/menu/TopBar'

const layoutRegistry = {
  default: ({ children, layoutProps }) => (
    <BaseLayout
      showHeader={true}
      showSidebar={true}
      header={<TopBar sidebarProps={{ width: 210, collapsedWidth: 64 }} />}
      sidebar={<SideMenu width={210} collapsedWidth={64} />}
      sidebarProps={{ width: 210, collapsedWidth: 64 }}
      layoutProps={{ ...layoutProps }}
    >
      {children}
    </BaseLayout>
  ),

  minimal: ({ children, layoutProps }) => (
    <BaseLayout
      showHeader={false}
      showSidebar={false}
      layoutProps={{ ...layoutProps }}
    >
      {children}
    </BaseLayout>
  ),

  particleBackground: ({ children }) => (
    <AnimatedBackgroundLayout
      background={<ParticlesBackground></ParticlesBackground>}
    >
      {children}
    </AnimatedBackgroundLayout>
  ),
}

export default layoutRegistry
